import { useState } from 'react';

import { executeQuery } from 'common/gql';
import type { HomeClubModalQuery } from 'common/gql/generated/schema';
import { useLocalization } from 'common/providers/LocaleProvider';
import { hasHomeClubSubscriptionModalConditions } from 'common/utils/homeclub';
import homeClubCouponUserQuery from '../../gql/query/homeclub-modal.gql';

export const getHomeClubModalData = async () => {
  const response = await executeQuery<HomeClubModalQuery>({
    query: homeClubCouponUserQuery,
  });

  return response.user;
};

interface UseHomeClubModalProps {
  setCommonError: (message: string) => void;
  initialDiscountPendingTotal?: number;
}

export const useHomeClubModal = ({
  setCommonError,
  initialDiscountPendingTotal,
}: UseHomeClubModalProps) => {
  const { t } = useLocalization();

  const [isHomeClubModalOpen, setIsHomeClubModalOpen] = useState(false);
  const [discountPendingTotal, setDiscountPendingTotal] = useState<number | null>(
    initialDiscountPendingTotal ?? null
  );

  const checkAndShowHomeClubModal = async () => {
    try {
      const homeClubModalData = await getHomeClubModalData();

      if (
        !homeClubModalData.homeClub.code &&
        hasHomeClubSubscriptionModalConditions(
          true,
          homeClubModalData?.cart?.cart?.discountPendingTotal
        )
      ) {
        setIsHomeClubModalOpen(true);
        setDiscountPendingTotal(homeClubModalData.cart?.cart?.discountPendingTotal ?? null);

        return true;
      }
    } catch {
      setCommonError(t('h24_something_went_wrong'));

      return true;
    }

    return false;
  };

  return { isHomeClubModalOpen, discountPendingTotal, checkAndShowHomeClubModal };
};
